var VrHeader = function() {
    var _this = this,
        _vrNavBtnSel = '.vr-nav-btn',
        _vrNavBtnOpenClass = 'vr-nav-btn_open',
        _vrHeaderCategoriesSel = '.vr-header-categories',
        _vrHeaderCategoriesOpenClass = 'vr-header-categories_open',
        _vrHeaderLabelClass = 'vr-header__label-btn',
        _vrHeaderLabelClickableClass = 'js-vr-header__label-btn',
        _vrHeaderOverlaySel = '.vr-header-overlay',
        _vrHeaderBrandInfoClass = 'vr-header-brand-info',
        _vrHeaderBrandInfoOpenClass = 'vr-header-brand-info_open',
        _vrHeaderBrandInfoBtnSel = '.vr-header__label-btn_info',
        _isFirstNavOpen = true,
        _actionKey = 'action',
        _actionFuncs = {
            'add_fav_brand': _addFavBrandLogged,
            'add_product_to_list': _addProductToListLogged,
            'add_fav_rel_brand': _addFavRelBrand,
            'add_fav_product': _addFavProduct,
            'add_fav_product_input': _addFavProductInput
        };


    function _toggleHtmlBlockScroll(hasOpenClass) {
        if (hasOpenClass === false) {
            $('html').addClass('vr-html-block-scroll');
        } else {
            $('html').removeClass('vr-html-block-scroll');
        }
    }

    function _toggleNavCats($el) {
        var target = $el.data('target'),
            targetOpen = $el.data('target-open');

        _toggleHtmlBlockScroll($el.hasClass(_vrNavBtnOpenClass));

        $el.toggleClass(_vrNavBtnOpenClass).find('.' + _vrHeaderLabelClass).toggleClass(_vrHeaderLabelClass + '_open');

        if (targetOpen === _vrHeaderCategoriesOpenClass) {
            $(target).toggleClass(_vrHeaderCategoriesOpenClass);

            if (_isFirstNavOpen) {
                var triggerEv = isMobile ? 'click' : 'mouseenter';

                $(target + ' .vr-cat-nav-item:first').trigger(triggerEv);
                _isFirstNavOpen = false;

                $('.vr-cat-nav-item-icon img').each(function(inx, item){
                    $(item).attr('src', $(item).data('cat-src'));
                });
            }
        }
    }

    function _toggleBrandInfo($el) {
        var target = $el.data('target'),
            targetOpen = $el.data('target-open');

        if ($el.closest(_vrNavBtnSel).length > 0) {
            return;
        }

        _toggleHtmlBlockScroll($(target).hasClass(targetOpen));

        $el.toggleClass(_vrHeaderLabelClass + '_open');
        $(target).toggleClass(targetOpen);
    }

    function _handleBrandInfoClicks(e) {
        var $el = $(this);

        // $el.
        if ($el.hasClass('vr-header-brand-info-bottom__item_fav')) {

        } else if ($el.hasClass('vr-header-brand-info-bottom__item_subscribe')) {
        } else if ($el.hasClass('vr-header-brand-info-bottom__item_add-product')) {

        }
    }


    function _handleClickEvents() {
        $(document).on('click', _vrNavBtnSel, function(e) {
            var $el = $(this),
                target = $el.data('target'),
                targetOpen = $el.data('target-open');


            if ($('.vr-header__label-btn_info.' + _vrHeaderLabelClass + '_open').length > 0 && $el.hasClass('.vr-header__label-btn_info' + _vrHeaderLabelClass + '_open') === false) {
                _toggleBrandInfo($('.vr-header__label-btn_info'));
            }

            _toggleNavCats($el);
        });

        $(document).on('click', '.' + _vrHeaderLabelClickableClass + ':not(.vr-header__label-btn_sandwitch)', function(e) {
            var $el = $(this),
                target = $el.data('target'),
                targetOpen = $el.data('target-open');

            if ($('.' + _vrNavBtnOpenClass).length > 0 && $el.hasClass(_vrNavBtnOpenClass) === false) {
                _toggleNavCats($(_vrNavBtnSel));
            }

            _toggleBrandInfo($el);
        });


        $(document).on(isMobile ? 'touchend' : 'click', _vrHeaderOverlaySel, function(e) {
            var $el = $(this),
                $elPrev = $el.prev();

            e.preventDefault();
            e.stopPropagation();

            if ($elPrev.hasClass(_vrHeaderCategoriesOpenClass) === true) {
                $(_vrNavBtnSel).trigger('click');
                // $elPrev.removeClass(_vrHeaderCategoriesOpenClass);
            } else if ($elPrev.hasClass(_vrHeaderBrandInfoClass) === true) {
                $(_vrHeaderBrandInfoBtnSel).trigger('click');
                // $elPrev.removeClass(_vrHeaderBrandInfoOpenClass);
            }
        });

        $(document).on(isMobile ? 'touchend' : 'click', '.vr-header-categories-btn_close', function(e) {
            e.preventDefault();
            e.stopPropagation();
            ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'header-menu-close-button', window.location.href);
            _toggleNavCats($(_vrNavBtnSel));
        });


        $(document).on(isMobile ? 'touchend' : 'click', '.vr-header-brand-info-btn_close', function(e) {
            e.preventDefault();
            e.stopPropagation();
            ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'info-menu-close-button', window.location.href);
            _toggleBrandInfo($('.vr-header__label-btn_info'));
        });

        $(document).on(isMobile ? 'touchend' : 'click', '.vr-header-brand-info-bottom__item', _handleBrandInfoClicks);

        function _showLoginPopupOnClick(){
            $(document).on('click', '.sh-profile-login', function(e){
                e.preventDefault();
                var $el = $(this),
                    loginTitle = "";

                if($el.hasClass('vr-header-brand-info-bottom__item_fav')){
                    loginTitle = viewLang.login_to_add_fav_brand;
                }else if($el.hasClass('vr-header-brand-info-bottom__item_add-product')){
                    loginTitle = viewLang.login_to_product;
                }else if($el.hasClass('vr-catalog__icon-default')){
                    loginTitle = viewLang.login_to_add_fav_brand;
                }else if($el.hasClass('vr-product__btn')){
                    loginTitle = viewLang.login_to_product;
                }else if($el.hasClass('vr-shopping-list__btn')){
                    loginTitle = viewLang.login_to_product;
                }

                _toggleHtmlBlockScroll(false);

                _setUrlByAction(this);

                upLogin.openLoginPopup(function(){
                    if(loginTitle !== ''){
                        $('#up-login-popup .up-main-form-title').text(loginTitle);
                    }
                }, function(){
                    _toggleHtmlBlockScroll(true);
                });

                $('#up-login-popup').closest('.mfp-container').css('overflow', 'auto');
            });
        }

        if(isMobile){
            setTimeout(function(){
                _showLoginPopupOnClick();
            },500);    
        }else{
             _showLoginPopupOnClick()
        }

        $(document).on(isMobile ? 'touchend' : 'click', '.js-add-fav-brand', function(e){
            var $el = $(this),
                _selectedBrandsArr = [ $el.data("brand-id") ];

            if($el.hasClass('sh-profile-login') === true){
                return;
            }

            $.post("/profile/like_brand", {
                selectedBrandsArr: _selectedBrandsArr,
            }, function(data) {
            });
            
            $el.toggleClass('vr-header-brand-info-bottom__item_fas-clicked');
        });
    }
        
    function _setUrlByAction(el){
        var $el = $(el),
            action = "",
            actionUrl = "";
    
        if($el.hasClass('js-add-product-to-list') === true){
            action = 'add_product_to_list';
        }

        if($el.hasClass('js-add-fav-brand') === true){
            action = 'add_fav_brand';
        }

        if($el.hasClass('vr-catalog__icon-default') === true){
            var brochureId = $(el).closest(".vr-none").data("brochure-id");
            sessionStorage.setItem('brochureId', brochureId);
            action = 'add_fav_rel_brand';
        }

        if($el.hasClass('vr-product__btn') === true){
            var productId = $(el).data("product-id");
            sessionStorage.setItem('productId', productId);
            action = 'add_fav_product';
        }

        if($el.hasClass('vr-shopping-list__btn') === true){
            var inputProduct = $(".vr-shopping-list__middle input").val().trim();
            sessionStorage.setItem('inputProduct', inputProduct);
            action = 'add_fav_product_input';
        }
        
        if(action !== ''){
            actionUrl = window.location.origin + window.location.pathname + (window.location.search !== '' ? window.location.search + '&' + _actionKey +'=' : '?' + _actionKey + '=') + action + window.location.hash;        
            history.replaceState('', document.title, actionUrl);
        }
    }

    function _executeActionByUrl(){
        var action = '';

        if(window.location.search !== ''){
            action = window.location.search.substr(window.location.search.indexOf(_actionKey + '=') + (_actionKey + '=').length);

            if(action.indexOf('&') > -1){
                action = action.substr(action, action.indexOf('&'));
            }
            
            if(typeof _actionFuncs[action] === 'function'){
                _removeActionFromUrl(action);
                _actionFuncs[action](action);
            }
        }
    }

    function _removeActionFromUrl(action){
        var actionUrl = window.location.href.replace(_actionKey + '=' + action, '');
        history.replaceState('', document.title, actionUrl);
    }
    
    function _addFavBrandLogged(){
        $('.js-vr-header__label-btn').click();
        
        setTimeout(function(){
            $('.js-add-fav-brand').click();
            ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'login-profile-favourite',  window.location.href);
        }, 10);
    }

    function _addProductToListLogged(){
        $('.js-vr-header__label-btn').click();
        
        setTimeout(function(){
            $('.js-add-product-to-list').click();
            ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'login-profile-add-product',  window.location.href);
        }, 10);
    }

    function _addFavRelBrand(action){
        var dataBrochureId = sessionStorage.getItem('brochureId');
        setTimeout(function(){
            $(".vr-none[data-brochure-id='"+dataBrochureId+"'] .vr-catalog__icon-default").click();
        }, 100);
    }

    function _addFavProduct(action){
        var dataProductId = sessionStorage.getItem('productId');
        setTimeout(function(){
            $(".vr-product__btn[data-product-id='"+dataProductId+"']").click();
        }, 100);
    }

    function _addFavProductInput(action){
        var dataInputProduct = sessionStorage.getItem('inputProduct');
            $.ajax({
                type: "POST",
                url: "/profile/add_in_shopping_list",
                data: { "name": dataInputProduct },
                dataType: 'json',
                success: function(data) {

                    var productShopList =
                        '<div class="vr-shopping-list__item" data-action="1" data-id="' + data.product_id + '">' +
                        '<div class="vr-shopping-list__item_label vr-shopping-list__item_bought">' + dataInputProduct + '</div>' +
                        '<div class="vr-shopping-list__item_controls">' +
                        '<a class="vr-shopping-list_btn vr-shopping-list_btn_search ignore-click" data-action="search" target="_blank"' + ' href="/search?search=' + dataInputProduct + '"></a>' +
                        '<button class="vr-shopping-list_btn vr-shopping-list_btn_delete vr-shopping-list_item_input" type="button" data-action="0"></button>' +
                        '</div>' +
                        '</div>';

                    $(".vr-shopping-list__buy_items .iscroll-inner").prepend(productShopList);
                    $(".vr-shopping-list__middle input").val("");
                        vrProductsBottom.iscrollShopList();

                    ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'add-product-button-shopping-list', dataInputProduct);

                },
                error: function(err) {
                    console.log("error")
                }
            });
    }

    function _removeDoubleTapForIphone() {
        $('.up-nav-item').on('touchstart', function(e) {
            var el = $(this);
            var link = el.attr('href');
            window.location = link;
        });
    }

    function _init() {
        _handleClickEvents();
        _executeActionByUrl();

        /* Hidden because of task OF-3412 */
        // _showScrollClue();
        // setTimeout(_handleScroll, 3000);
    }

    _init();

    _this.init = _init;
    _this.toggleHtmlBlockScroll = _toggleHtmlBlockScroll;
};